import { connect } from 'react-redux';
import { simoSubPage } from 'decorators/subPage';
import SimoSubNav from 'components/SubNav/simo';
import NewLease from './NewLease';

const mapStateToProps = (state, { subId, sub }) => ({
  initialValues: {
    lease_details: {
      subscription: null, // should be null, required in api
      att_subscription: null, // should be null, required in api
      tracfone_subscription: null, // should be null, required in api
      simo_subscription: +subId,
      imei: sub && sub.imei,
      product: null,
    },
  },
  SubNav: SimoSubNav,
});

export default simoSubPage(connect(mapStateToProps, null)(NewLease));
